<template>
    <div @click="closeClickToEditComponents">
        <alert v-if="hasInvalidAttributes && !readOnly" :text="$t('shared.auction_data_viewer.consider_red_marks')" :headline="$t('shared.auction_data_viewer.warning')" class="mb-5"></alert>
        <div class="font-medium border-b-2 border-gray-200 mb-4" v-if="showHeadlines">{{$t('shared.auction_data_viewer.auction_attributes')}}</div>
        <div class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 auto-cols-max gap-2 mb-4" :class="gridColStyle">
            <div class="auction-attribute-container" v-if="hasField('id')">
                <span class="text-xl">{{ campaign.id }}</span><br/>
                <span class="text-sm">{{$t('shared.campaign_data_viewer.id')}}</span>
            </div>
            <div class="auction-attribute-container" v-if="hasField('name')">
                <span class="text-xl">{{ campaign.name }}</span><br/>
                <span class="text-sm">{{$t('shared.campaign_data_viewer.name')}}</span>
            </div>
            <div class="auction-attribute-container" v-if="hasField('date_start')">
                <span class="text-xl">{{ campaign.date_start | formatDate }}</span><br/>
                <span class="text-sm">{{$t('shared.campaign_data_viewer.date_start')}}</span>
            </div>
            <div class="auction-attribute-container" v-if="hasField('date_end')">
                <span class="text-xl">{{ campaign.date_end | formatDate }}</span><br/>
                <span class="text-sm">{{$t('shared.campaign_data_viewer.date_end')}}</span>
            </div>
            <div class="auction-attribute-container" v-if="hasField('auctions_auto_play')">
                <span class="text-xl">{{ parseInt(campaign.auctions_auto_play) === 0 ? $t('shared.campaign_data_viewer.autopilot_inactive') : $t('shared.campaign_data_viewer.autopilot_active') }}</span><br/>
                <span class="text-sm">{{$t('shared.campaign_data_viewer.autopilot')}}</span>
            </div>
            <div class="auction-attribute-container" v-if="hasField('preview_duration')">
                <click-to-edit
                    @update="valueUpdated"
                    @state="stateChanged"
                    :forceClose="forceClickToEditClose"
                    :allowed="!readOnly"
                    :type="`number`"
                    :name="`auctions_preview_duration`"
                    :step="1"
                    :min="0"
                    :origin="campaign.auctions_preview_duration">
                    <span class="text-xl" v-if="campaign.auctions_preview_duration > 0">{{ campaign.auctions_preview_duration }}s</span>
                    <span class="text-xl" v-else-if="campaign.auctions_preview_duration === 0">{{$t('shared.auction_data_viewer.manual')}}</span>
                    <span class="text-xl" v-else>{{$t('shared.auction_data_viewer.deactivated')}}</span>
                </click-to-edit>
                <span class="block mt-1 text-sm">{{$t('shared.campaign_data_viewer.preview')}}</span>
            </div>
            <div class="auction-attribute-container" v-if="hasField('preview_duration')">
                <click-to-edit
                    @update="valueUpdated"
                    @state="stateChanged"
                    :forceClose="forceClickToEditClose"
                    :allowed="!readOnly"
                    :type="`number`"
                    :name="`auctions_trail_duration`"
                    :step="1"
                    :min="0"
                    :origin="campaign.auctions_trail_duration">
                    <span class="text-xl" v-if="campaign.auctions_trail_duration > 0">{{ campaign.auctions_trail_duration }}s</span>
                    <span class="text-xl" v-else-if="campaign.auctions_trail_duration === 0">{{$t('shared.auction_data_viewer.manual')}}</span>
                    <span class="text-xl" v-else>{{$t('shared.auction_data_viewer.deactivated')}}</span>
                </click-to-edit>
                <span class="block mt-1 text-sm">{{$t('shared.campaign_data_viewer.trailing')}}</span>
            </div>
            <div class="auction-attribute-container" v-if="hasField('updated_at')">
                <span class="text-xl">{{ campaign.updated_at | formatDate }}</span><br/>
                <span class="text-sm">{{$t('shared.campaign_data_viewer.updated_at')}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import ClickToEdit from "@/Shared/ClickToEdit";
    import AuctionState from "@/mixins/AuctionState";
    import Alert from "@/Shared/Alert";
    export default {
        mixins: [
            AuctionState
        ],
        components: {
            Alert,
            ClickToEdit,
        },
        props: {
            campaign: Object,
            context: {
                type: Object,
                default: () => { return {} }
            },
            readOnly: {
                type: Boolean,
                default: true
            },
            showHeadlines: {
                type: Boolean,
                default: true
            },
            fields: {
                type: Array,
                default: () => { return [] }
            },
            cols: {
                type: Number,
                default: 3
            }
        },
        data() {
          return {
              activeClickToEdits: 0,
              forceClickToEditClose: false,
              clickToEditState: {
                  start_price: {
                      new: null,
                      old: null
                  }
              }
          }
        },
        mounted() {
            this.$emit('campaign-validated', !this.hasInvalidAttributes);
        },
        computed: {
            gridColStyle() {
              return {
                  'grid-cols-1': this.cols === 1,
                  'grid-cols-2': this.cols === 2,
                  'grid-cols-3': this.cols === 3,
                  'grid-cols-4': this.cols === 4,
                  'grid-cols-5': this.cols === 5,
                  'grid-cols-6': this.cols === 6,
                  'grid-cols-7': this.cols === 7,
              }
            },
            hasInvalidAttributes() {
                return false;
            },
        },
        methods: {
            hasField(field) {
              return this.fields.length === 0 || this.fields.includes(field);
            },
            closeClickToEditComponents() {
                if (this.activeClickToEdits > 0) {
                    this.forceClickToEditClose = true;
                }
            },
            stateChanged(val) {
                if (val) {
                    this.activeClickToEdits++;
                } else {
                    this.activeClickToEdits--;
                }
                if (0 === this.activeClickToEdits) {
                    this.forceClickToEditClose = false;
                }
            },
            valueUpdated(val) {
              this.$emit('auction-update', val);
              this.closeClickToEditComponents();
            },
        },
        watch: {
            hasInvalidAttributes(val) {
                this.$emit('auction-validated', !this.hasInvalidAttributes);
            }
        }
    }
</script>
